import React, { useState, useRef, useEffect, useCallback } from "react";
import { ReactComponent as ArrowRight } from "../../assets/icons/arrowright.svg";
import { useNavigate } from "react-router-dom";
import { AES, enc } from "crypto-js";
import { CommonToast } from "./Toast";
import { ReactComponent as Logo } from "../../assets/images/logo.svg";


const { REACT_APP_VERIFICATION_CODE, REACT_APP_PUBLIC_ACCESS_TOKEN, REACT_APP_ENVIRONMENT, } = process.env;
const Verification = () => {
    const inputRefs = useRef([]);
    const navigate = useNavigate();
    const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    const [isButtonValid, setIsButtonValid] = useState(false);
    const [error, setError] = useState(false);
    const [blockedUser, setBlockedUser] = useState(false);
    const [errorMessage, setErrorMessage] = useState("Wrong OTP Please Try Again");

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (otp?.join('') === REACT_APP_VERIFICATION_CODE) {
            const ciphertext = AES.encrypt(REACT_APP_VERIFICATION_CODE, REACT_APP_PUBLIC_ACCESS_TOKEN).toString();
            localStorage.setItem('appvalue', ciphertext);
            const loginTime = new Date().getTime();
            localStorage.setItem('loginTime', loginTime.toString());
            CommonToast.success("App verification is Successful");
            navigate('/login')
        }
        else {
            CommonToast.error('Invalid OTP, Contact Admin for support')
        }
    };

    useEffect(() => {
        if (REACT_APP_ENVIRONMENT === 'testing' || REACT_APP_ENVIRONMENT === 'development') {
            const verificationCode = localStorage.getItem('appvalue');
            if (verificationCode) {
                const bytes = AES?.decrypt(verificationCode ?? "", REACT_APP_PUBLIC_ACCESS_TOKEN);
                const originalText = bytes?.toString(enc.Utf8);
                originalText === REACT_APP_VERIFICATION_CODE && navigate('/home')
            }
        } else {
            navigate('/home');
        }
    }, [])

    const handleChange = (e, index) => {
        const inputValue = e.target.value?.replace(/[^0-9]/g, '');
        const newOtp = [...otp];
        newOtp[index] = inputValue;
        setOtp(newOtp);
        if (inputValue !== "" && index < 5) {
            inputRefs.current[index + 1].focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && otp[index] === "" && index > 0) {
            inputRefs.current[index - 1].focus();
        }
    };

    const validate = useCallback(() => {
        let has6Digits = otp.every((item) => item !== "");
        setIsButtonValid(has6Digits);
    }, [otp]);

    useEffect(() => {
        validate();
    }, [validate]);

    const handlePaste = (e) => {
        e.preventDefault();

        const pastedText = e.clipboardData.getData('text');

        // Update the OTP values based on the pasted text
        const newOtp = pastedText
            .split('')
            .slice(0, otp.length)
            .map((char) => char);

        setOtp(newOtp);
    };

    return (
        <section className="relative px-4 py-20 lg:py-0 overflow-hidden">
            <div className="px-0 mx-auto">
                <div className="mx-auto relative">
                    <div className="flex flex-wrap -mx-4 xl:items-center items-center">
                        <div className="flex-flex1 w-full lg:w-1/2 xl:w-3/5 px-4 order-last lg:order-first">
                            <div className="max-w-md lg:py-20 mx-auto ">
                                <h3 className="font-heading text-f24 sm:text-f36 text-primary font-bold mb-4 text-center">
                                    <div className="flex justify-center items-center md:mx-auto" style={{ margin: '10px' }}>
                                        <Logo />
                                    </div>
                                </h3>
                                <p className="text-lg text-secondary mb-10 text-center text-f14 sm:text-para3">
                                    Please enter the verification code to access Application
                                </p>
                                {!blockedUser && (
                                    <div className="inline-flex items-center justify-center space-x-2 mb-6">
                                        {otp.map((digit, index) => (
                                            <React.Fragment key={index}>
                                                {index > 0 && index % 3 === 0 && (
                                                    <div
                                                        className="w-5 h-12 bg-gray-300 self-center"
                                                        style={{ height: "5px" }}
                                                    ></div>
                                                )}
                                                <input
                                                    ref={(ref) => (inputRefs.current[index] = ref)}
                                                    regex="/[0-9]{1}$/"
                                                    maxLength={1} value={digit}
                                                    onChange={(e) => handleChange(e, index)}
                                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                                    onPaste={handlePaste}
                                                    className="w-12 h-12 text-2xl text-center border border-gray-400 rounded focus:outline-none focus:border-blue-500 bg-gray-100 placeholder-gray-400 placeholder-3xl"
                                                    placeholder="0"
                                                    type="password"
                                                    style={{ height: "45px" }}
                                                />
                                            </React.Fragment>
                                        ))}
                                    </div>
                                )}
                                {error && (
                                    <p className="mb-2 text-red-500">
                                        {errorMessage}
                                    </p>
                                )}
                                {!blockedUser && (
                                    <button
                                        className="relative group w-full mb-6 py-3 px-5 text-center text-sm font-semibold text-white bg-primary rounded-md  inline-flex items-center justify-center mr-2 gap-4"
                                        type="submit"
                                        onClick={handleSubmit}
                                        disabled={!isButtonValid}
                                    >
                                        <span className="relative">Next</span>
                                        <ArrowRight />
                                    </button>

                                )}
                                {/* {!blockedUser && (
                                    <div className="inline-flex items-center justify-center text-f14 gap-1 mr-2 text-secondary">
                                        <p>Didn't get the email? </p>
                                        <Link
                                            onClick={onPrev}
                                            className="cursor-pointer text-primaryText font-semibold"
                                        >
                                            Resend or edit your email address
                                        </Link>
                                    </div>
                                )}
                                {blockedUser && (
                                    <div className="inline-flex items-center justify-center text-f14 gap-1 mr-2 text-secondary">
                                        <p>Go back to</p>
                                        <Link
                                            onClick={onPrev}
                                            className="cursor-pointer text-primaryText font-semibold"
                                        >
                                            Login Page
                                        </Link>
                                        <p>and Try again</p>
                                    </div>
                                )} */}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Verification;
